import gearPath from '../paths';

export default `
<div class="controls-panel">
	<div class="panel_switch-view">
		<div id="switchUpArrow" class="switch-view_up-arrow">
			<img src="./assets/images/up-arrow.png">
		</div>
		<div class="switch-view_colors-section"></div>
		<div id="switchDownArrow" class="switch-view_down-arrow arrow-btn_hide">
			<img src="./assets/images/down-arrow.png">
		</div>
	</div>
	<div class="panel_section-container">
		<div class="panel_conditions-section_container">
			<div id="panel_conditions-section" class="panel_section panel_conditions-section">
				<p class="sectionLabel">Conditions</p>
				<button id="btnOffset" class="panel_btn" style="display: none;">Gradual Spin</button>
				<button id="btnHemA" class="panel_btn">Hemophilia A</button>
				<button id="btnHemB" class="panel_btn">Hemophilia B</button>
				<button id="btnvWD" class="panel_btn">von Willebrand</button>
			</div>
			<div id="panel_inhibitors-section" class="panel_section panel_inhibitors-section">
				<p class="sectionLabel">Inhibitors</p>
				<button id="btnHemA_HiTiter" class="panel_btn initial-hidden">High-titer Inhibitors</button>
				<button id="btnHemA_LowTiter" class="panel_btn initial-hidden">Low-titer Inhibitors</button>

				<button id="btnHemB_HiTiter" class="panel_btn initial-hidden">High-titer Inhibitors</button>
				<button id="btnHemB_LowTiter" class="panel_btn initial-hidden">Low-titer Inhibitors</button>

				<button id="btn_NoTiter" class="panel_btn initial-hidden">No Inhibitors</button>
			</div>
			<div id="panel_treatments-section" class="panel_section panel_treatments-section">
				<!--<button id="btnNormal">Coagulation Cascade</button> -->
				<p class="sectionLabel">Treatments</p>
				<button id="btnTrmtAaRF" class="panel_btn initial-hidden btn_treatments">Replacement Factor VIII</button>
				<button id="btnTrmtALoRF" class="panel_btn initial-hidden btn_treatments">High Replacement Factor VIII</button>
				<button id="btnTrmtAHiAPCC" class="panel_btn initial-hidden btn_treatments">aPCC</button>
				<button id="btnTrmtAHiFVIIIa" class="panel_btn initial-hidden btn_treatments">Factor VIIa</button>
				<button id="btnTrmtBaRF" class="panel_btn initial-hidden btn_treatments">Replacement Factor IX</button>
				<button id="btnTrmtBLoRF" class="panel_btn initial-hidden btn_treatments">High Replacement Factor IX</button>
				<button id="btnTrmtBHiAPCC" class="panel_btn initial-hidden btn_treatments">aPCC</button>
				<button id="btnTrmtBHiFVIIIa" class="panel_btn initial-hidden btn_treatments">Factor VIIa</button>
				<button id="btnTrmtDesmopressin" class="panel_btn initial-hidden btn_treatments">Desmopressin</button>
				<button id="btnTrmtvW" class="panel_btn initial-hidden btn_treatments">Replacement vWF</button>
				<button id="btnTrmtvWFVIII" class="panel_btn initial-hidden btn_treatments">Replacement vWF+FVIII</button>
			</div>
		</div>
		<div class="go-btn-container">
			<div class="panel_section panel_go-btn">
				<div class="gear">
					<?xml version="1.0" encoding="UTF-8" ?>
					<h1 class="medium-gear">GO</h1>
					<svg fill="#AFAFAF" version="1.1" viewBox="20 20 60 60" xmlns="http://www.w3.org/2000/svg">
						<circle cx="50" cy="50" r="17" stroke="#AFAFAF" stroke-width="5" fill="#FFFFFF" />${gearPath.gearPath01}</svg>
				</div>
			</div>
		</div>
	</div>
</div>
`



// WEBPACK FOOTER //
// ./src/js/html-modules/controls-panel-html.js